var data = [
	{
		bigtype: '家用电器',
		url: require('/public/images/cake.png'),
		smalltype: [
			{
				name: '生活电器',
				goods: ['取暖电器','吸尘器','净化器','扫地机器人','加湿器','熨斗','电风扇','冷风扇','插座']
			},
            {
				name: '厨房小电',
				goods: ['电饭煲','微波炉','电烤箱','电磁炉','电压力锅','豆浆机','咖啡机','面包机','榨汁机']
			},
            {
				name: '实力商家',
				goods: ['海尔','三星','飞利浦','九阳','海信']
			}
		]
	},
	{
		bigtype: '手机/数码',
		url: require('/public/images/cookies.png'),
		smalltype: [
			{
				name: '手机',
				goods: ['手机','对讲机','以旧换新','手机维修']
			},{
				name: '数码配件',
				goods: ['存储卡','三脚架/云台','相机包','滤镜','闪光灯','相机清洗','机身附件','镜头附件','读卡器']
			},{
				name: '智能设备',
				goods: ['智能手环','智能手表','智能眼镜','智能机器人','运动跟踪器','智能家居','体感机','无人机','其他配件']
			},{
				name: '实力商家',
				goods: ['小米','SONY','Nikon','华为','魅族手机','三星']
			}
		]
	},
	{
		bigtype: '家居/家具',
		url: require('/public/images/meat.png'),
		smalltype: [
			{
				name: '家具',
				goods: ['卧室家具','客厅家具','餐厅家具','书房家具','儿童家具']
			},{
				name: '灯具',
				goods: ['台灯','吸顶灯','LED灯','节能灯','落地灯']
			},{
				name: '厨具',
				goods: ['烹饪厨具','刀剪菜饭','水具酒具','茶具','咖啡具']
			},{
				name: '实力商家',
				goods: ['花颜巧语','糖衣小屋','卡拉迪克','暖春童话','华盛童装批发行','奈仕华童装旗舰店','斑蒂尼BONDYNI','猫儿朵朵','童衣阁']
			}
		]
	},
	{
		bigtype: '素食/卤味',
		url: require('/public/images/bamboo.png'),
		smalltype: [
			{
				name: '素食',
				goods: ['蒸蛋糕','脱水蛋糕','瑞士卷','铜锣烧','软面包','马卡龙','千层饼','甜甜圈','蒸三明治']
			},{
				name: '卤味',
				goods: ['干笋','鸭脖','猪手','鸭头','猪耳朵']
			},{
				name: '实力商家',
				goods: ['达利食品','米琪','迪莉娅','艾菲克','老昌','阿满']
			}
		]
	},
	{
		bigtype: '坚果/炒货',
		url: require('/public/images/nut.png'),
		smalltype: [
			{
				name: '坚果',
				goods: ['核桃','杏仁','开心果','榛子','松子','腰果']
			},{
				name: '炒货',
				goods: ['锅巴','花生','瓜子','栗子','玉米']
			},{
				name: '实力商家',
				goods: ['老奶奶','恰恰','酒鬼','真心','温州城五区']
			}
		]
	},
	{
		bigtype: '糖果/蜜饯',
		url: require('/public/images/candy.png'),
		smalltype: [
			{
				name: '糖果',
				goods: ['花生糖','软糖','奶糖','水果糖','酥糖','牛轧糖']
			},{
				name: '蜜饯',
				goods: ['葡萄干','地瓜干','蜜枣','无花果','柿子饼','猕猴桃干','糖樱桃']
			},{
				name: '实力商家',
				goods: ['不老林','徐福记','马大姐','金丝猴','小白兔']
			}
		]
	},
	{
		bigtype: '巧克力',
		url: require('/public/images/chocolate.png'),
		smalltype: [
			{
				name: '巧克力',
				goods: ['德芙','费列罗','金帝','好时','金莎','明治']
			},{
				name: '果冻',
				goods: ['喜之郎','蜡笔小新','亲亲果冻','金娃果冻','徐福记','旺旺食品','金丝猴']
			},{
				name: '实力商家',
				goods: ['妙久食品','达达食品','果真小店','锦食阁小店']
			}
		]
	},
	{
		bigtype: '海鲜/肉类',
		url: require('/public/images/fish.png'),
		smalltype: [
			{
				name: '海鲜',
				goods: ['鱼类','虾类','蟹类','贝类','海参','三文鱼','海鲜加工品']
			},{
				name: '肉类',
				goods: ['猪肉','牛肉','羊肉','鸡肉','鸭肉','冷鲜肉','特色肉类']
			},{
				name: '实力商家',
				goods: ['双汇','华正','高金','皓月','海天下','美佳佳']
			}
		]
	},
	{
		bigtype: '花茶/名酒',
		url: require('/public/images/tea.png'),
		smalltype: [
			{
				name: '花茶',
				goods: ['铁观音','普洱','绿茶','红茶','龙井','乌龙茶','茉莉花茶']
			},{
				name: '名酒',
				goods: ['白酒','葡萄酒','洋酒','啤酒','黄酒','养生酒','陈年老酒']
			},{
				name: '实力商家',
				goods: ['茅台','劲牌','泸州老窖','竹叶青','西凤','蓝色经典']
			}
		]
	},
	{
		bigtype: '箱包',
		url: require('/public/images/package.png'),
		smalltype: [
			{
				name: '精品男包',
				goods: ['男士钱包','男士手包','双肩包','公文包','男士腰带','单肩斜挎']
			},{
				name: '旅行箱包',
				goods: ['拉杆箱包','电脑包','书包','休闲运动','旅行包','旅行配件']
			},{
				name: '实力商家',
				goods: ['美屡自营','安德里自营','巴特利专卖','皮尔卡丹','老人头','金利来']
			}
		]
	},
];
export default data;
